import { render, staticRenderFns } from "./myRed.vue?vue&type=template&id=5c8a4736&scoped=true"
import script from "./myRed.vue?vue&type=script&lang=js"
export * from "./myRed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a4736",
  null
  
)

export default component.exports